import { checkResponse } from "src/components/js/statics1";
import tyomaaClass from "../tyomaaClass";
import authClass from "../auth/auth";
import {
  cache_clear,
  cache_read,
  cache_write,
  tyomaa_cacheName,
} from "src/components/js/CacheFunctions";

export async function tyomaa_delete(tyomaaId, token) {
  cache_clear(tyomaa_cacheName);
  const requestOptions = {
    method: "DELETE",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/tyomaa/delete/" + tyomaaId,
    requestOptions
  );
  const cResponse = await checkResponse(response, "tyomaaClass:deleteTyomaa");
  return cResponse.success;
}

export async function tyomaa_fetch(personId, tyomaaId, token, keikkaId = null) {
  if (!tyomaaId) return new tyomaaClass();
  if (tyomaaId === 0) return new tyomaaClass();

  const addr = "/api/tyomaa/get/" + tyomaaId + "/" + keikkaId;
  const fullUrl = import.meta.env.VITE_SERVER_URL + addr;
  const cacheData = cache_read(tyomaa_cacheName, fullUrl);
  if (cacheData) return cacheData;

  const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
    method: "GET",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResult = await checkResponse(response, "tyomaaClass:fetchTyomaa");
  const result = cResult.data;
  const keikkaTyomaa = new tyomaaClass();
  const globalTyomaa = new tyomaaClass();
  if (keikkaId === null) keikkaTyomaa.setTyomaa(null);
  else keikkaTyomaa.setTyomaa(result.keikkaTyomaa);
  globalTyomaa.setTyomaa(result.globalTyomaa);
  const _auth = new authClass();
  await _auth.init(personId, 0, tyomaaId, 0, 1, token);
  keikkaTyomaa.auth = _auth.tyomaaAuth;
  globalTyomaa.auth = _auth.tyomaaAuth;
  cache_write(tyomaa_cacheName, fullUrl, { keikkaTyomaa, globalTyomaa });
  return { keikkaTyomaa: keikkaTyomaa, globalTyomaa: globalTyomaa };
}

export async function tyomaa_fetchKeikkaCount(tyomaaId, token) {
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      tyomaaId: tyomaaId,
    }),
  };
  const url = import.meta.env.VITE_SERVER_URL + "/api/tyomaa/keikkaCount";
  const response = await fetch(url, requestOptions);
  const cResponse = await checkResponse(response, "tyomaaClass:fetchKeikkaCount");
  if (!cResponse.success) return;
  const result = cResponse.data;
  return result.keikkaCount;
}

export async function tyomaa_fetchList_forPerson(personId, tyomaaId, token) {
  try {
    let url = "/api/tyomaa/list/" + personId + "/" + (tyomaaId || -1); // default: filter==="tyomaa"
    const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(response, "tyomaaClass:fetchTyomaaList");
    if (!cResponse.success) return [];
    return cResponse.data;
  } catch (err) {
    console.log(err);
  }
}

export async function tyomaa_fetchList_forAsiakas(asiakasId, token) {
  try {
    const url = "/api/tyomaa/asiakasTyomaaList/" + asiakasId;
    const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(response, "tyomaaClass:fetchTyomaaList");
    if (!cResponse.success) return [];
    return cResponse.data;
  } catch (err) {
    console.log(err);
  }
}

export async function tyomaa_removePerson(personId, tyomaaId, token) {
  cache_clear(tyomaa_cacheName);
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      personId: personId,
      tyomaaId: tyomaaId,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/tyomaa/person/remove",
    requestOptions
  );
  if (!(await checkResponse(response).success) === false) return false;
  return true;
}

export async function tyomaa_addPerson(personId, tyomaaId, token, contactPersonTypeId = 0) {
  cache_clear(tyomaa_cacheName);
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      personId: personId,
      tyomaaId: tyomaaId,
      contactPersonTypeId: contactPersonTypeId,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/tyomaa/person/add",
    requestOptions
  );
  if (!(await checkResponse(response).success) === false) return false;
  return true;
}

/**
 *
 * @param {string} token
 * @param {number} ownerAsiakasId
 * @returns {Promise<tyomaaClass[]>}
 * @description Fetches all tyomaa for ownerAsiakasId. If ownerAsiakasId is null, fetches all tyomaa for all owners.
 *
 */
export async function tyomaa_list(token, ownerAsiakasId = null) {
  const addr = "/api/tyomaa/listAll/" + ownerAsiakasId;
  const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
    method: "GET",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "tyomaaClass:fetchTyomaaListAll");
  if (!cResponse.success) return [];
  const result = cResponse.data;
  return result;
}

export async function tyomaa_search(
  ownerAsiakasId,
  searchString,
  token,
  signal = null,
  usingFullTextSearch = true
) {
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ownerAsiakasId: ownerAsiakasId,
      searchString: searchString,
      usingFullTextSearch: usingFullTextSearch,
      signal: signal,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/tyomaa/search/",
    requestOptions
  );
  const cResponse = await checkResponse(response, "searchTyomaa");
  if (!cResponse.success) {
    console.log(cResponse.message);
    return [];
  }
  const result = cResponse.data;
  return result;
}

export async function tyomaa_create(
  tyomaaNimi,
  creatorPersonId,
  ownerAsiakasId,
  token,
  keikkaId = 0,
  osoite1 = null,
  osoite2 = null,
  osoite3 = null,
  osoite4 = null,
  kommentti = null
) {
  cache_clear(tyomaa_cacheName);

  const tyomaa = new tyomaaClass();
  tyomaa.tyomaaNimi = tyomaaNimi;
  tyomaa.ownerAsiakasId = ownerAsiakasId;
  tyomaa.tyomaaOsoite1 = osoite1;
  tyomaa.tyomaaOsoite2 = osoite2;
  tyomaa.tyomaaOsoite3 = osoite3;
  tyomaa.tyomaaOsoite4 = osoite4;
  tyomaa.tyomaaContactPersonId = creatorPersonId;
  tyomaa.keikkaId = keikkaId;
  tyomaa.tyomaaMemo = kommentti;

  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(tyomaa),
  };
  const response = await fetch(import.meta.env.VITE_SERVER_URL + "/api/tyomaa/new", requestOptions);
  const cResponse = await checkResponse(response, "tyomaaClass:tyomaa_create");
  if (!cResponse.success) return 0;
  const result = cResponse.data;
  return result.returnValue;
}

export function tyomaa_ajoOhje_getString(tyomaa) {
  try {
    let a = tyomaa.tyomaaAjoOhje ? tyomaa.tyomaaAjoOhje + "" : "";
    let b = tyomaa.keikkaAjoOhje ? tyomaa.keikkaAjoOhje + "" : "";
    if (a != "" && b != "") return a + ". " + b;
    else if (a != "") return a;
    else if (b != "") return b;
    else return "";
  } catch {
    return "err";
  }
}

export function tyomaa_osoite_getString(tyomaa) {
  return (
    (tyomaa.tyomaaOsoite1 || "") +
    (tyomaa.tyomaaOsoite2 ? ", " + tyomaa.tyomaaOsoite2 : "") +
    " " +
    (tyomaa.tyomaaOsoite3 ? ", " + tyomaa.tyomaaOsoite3 : "") +
    " " +
    (tyomaa.tyomaaOsoite4 || "")
  )
    .replaceAll("  ", " ")
    .trim();
}

export async function tyomaa_save_to_db(tyomaa, token, saveGlobalTyomaa = false, keikkaId = null) {
  cache_clear(tyomaa_cacheName);
  if (keikkaId == null) saveGlobalTyomaa = true;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      tyomaaId: tyomaa.tyomaaId,
      asiakasId: tyomaa.asiakasId || 0,
      tyomaaNimi: tyomaa.tyomaaNimi.trim(),
      tyomaaAjoOhje: tyomaa.tyomaaAjoOhje.trim(),
      tyomaaOsoite1: tyomaa.tyomaaOsoite1.trim(),
      tyomaaOsoite2: tyomaa.tyomaaOsoite2.trim(),
      tyomaaOsoite3: tyomaa.tyomaaOsoite3.trim(),
      tyomaaOsoite4: tyomaa.tyomaaOsoite4.trim(),
      laskuViite: tyomaa.laskuViite ? tyomaa.laskuViite.trim() : "",
      tyomaaMemo: tyomaa.tyomaaMemo ? tyomaa.tyomaaMemo.trim() : "",
      tyomaaContactPersonId: tyomaa.tyomaaContactPersonId,
      keikkaId: keikkaId,
      saveGlobalTyomaa: saveGlobalTyomaa,
      ownerAsiakasId: tyomaa.ownerAsiakasId,
      tyomaaNum: tyomaa.tyomaaNum ? tyomaa.tyomaaNum.trim() : "",
    }),
  };
  const url =
    import.meta.env.VITE_SERVER_URL +
    (tyomaa.tyomaaId === 0 ? "/api/tyomaa/new" : "/api/tyomaa/set");

  if (tyomaa.tyomaaId === 0) {
    //create new tyomaaId
    const response = await fetch(url, requestOptions);
    const cResponse = await checkResponse(response, "tyomaaClass:saveTyomaaToDb");
    if (!cResponse.success) return 0;
    const result = cResponse.data;
    return result.returnValue;
  } else {
    // save tyomaaData
    if (tyomaa.originalHash === tyomaa.tyomaaHash) {
      return tyomaa.tyomaaId;
    }

    await fetch(url, requestOptions)
      .then(() => {
        tyomaa.originalHash = tyomaa.tyomaaHash;
        return tyomaa.tyomaaId;
      })
      .catch((error) => console.log(error));
  }
}

/**
 *
 * @param {*} tyomaa
 * @param {*} token
 * @param {*} keikkaId
 * @returns {boolean} true if tyomaa addresses were fixed (corrected)
 */
export async function tyomaa_fixTyomaaAddresses(tyomaa, token, keikkaId) {
  if (!tyomaa || tyomaa.tyomaaId == 0) return false;
  try {
    let didFix = false;
    const _tyomaa = tyomaa;
    let _osoite1 = _tyomaa.tyomaaOsoite1.replace("Hki", "Helsinki");
    let _osoite2 = _tyomaa.tyomaaOsoite2.replace("Hki", "Helsinki");
    let _osoite3 = _tyomaa.tyomaaOsoite3.replace("Hki", "Helsinki");
    let _osoite4 = _tyomaa.tyomaaOsoite4.replace("Hki", "Helsinki");
    const regex = /^(\d{5})\s(.+)$/;
    if ((_osoite3 == null || _osoite3.length < 2) && (_osoite4 == null || _osoite4.length < 2)) {
      // check if _tyomaa.tyomaaOsoite2 matches regex ^(\d{5})\s(.+)$
      // if it does, set osoite3 to match1 and osoite4 to match2
      const match = _tyomaa?.tyomaaOsoite2 && _tyomaa.tyomaaOsoite2.match(regex);
      if (match) {
        const _os2 = "";
        const _os3 = match[1];
        const _os4 = fixCityName(match[2]);
        _tyomaa.tyomaaOsoite2 = _os2;
        _tyomaa.tyomaaOsoite3 = _os3;
        _tyomaa.tyomaaOsoite4 = _os4;
        _osoite2 = _os2;
        _osoite3 = _os3;
        _osoite4 = _os4;
        await tyomaa_save_to_db(_tyomaa, token, true, keikkaId);
        console.log("regex match found and fixed", keikkaId);
        didFix = true;
      } else {
        //console.log("fixTyomaaAddresses: no errors found");
        didFix = false;
      }
    }
    if (_osoite1 && _osoite1.includes(",")) {
      // if tyomaaOsoite1 contains ',' then take the last part and set it to tyomaaOsoite4
      const parts = _osoite1.split(",");
      _tyomaa.tyomaaOsoite1 = parts[0];
      _tyomaa.tyomaaOsoite4 = parts[1];
      _osoite1 = parts[0];
      _osoite4 = fixCityName(parts[1]);
      await tyomaa_save_to_db(_tyomaa, token, true, keikkaId);
      console.log("comma found and fixed", keikkaId);
      didFix = true;
    } else if (_osoite2 && _osoite2.length > 0 && !_osoite3 && !_osoite4) {
      // if tyomaaOsoite2 contains anything and tyomaaOsoite3 is null and tyomaaOsoite4 is null then set tyomaaOsoite2 to tyomaaOsoite4
      _tyomaa.tyomaaOsoite4 = fixCityName(_osoite2);
      _tyomaa.tyomaaOsoite2 = "";
      _osoite4 = fixCityName(_osoite2);
      _osoite2 = "";
      await tyomaa_save_to_db(_tyomaa, token, true, keikkaId);
      didFix = true;
      console.log("tyomaaOsoite2 found and fixed", keikkaId);
    }
    if (!_osoite3 || _osoite3.trim() == "") {
      // jos postinumero puuttuu mutta sen on formattedAddressissa niin käytä sieltä
      const match = _tyomaa?.formattedAddress.match(/(\d{5})\s(.+)$/);
      if (match) {
        const _os3 = match[1];
        _tyomaa.tyomaaOsoite3 = _os3;
        _osoite3 = _os3;
        await tyomaa_save_to_db(_tyomaa, token, true, keikkaId);
        didFix = true;
        console.log("tyomaaOsoite3 (postinumero) found from google and fixed", keikkaId);
      }
    }
    return didFix;
  } catch (err) {
    console.log("fixTyomaaAddresses error");
    console.log(err);
    return null;
  }
}

function fixCityName(city) {
  if (!city) return "";
  if (city == "hki") return "Helsinki";
  return city;
}

export async function tyomaaContactPerson_set(tyomaaId, personId, token) {
  cache_clear(tyomaa_cacheName);
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      tyomaaId: tyomaaId,
      personId: personId,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/tyomaa/contactPerson/set",
    requestOptions
  );
  return response.ok;
}
